import React from "react";
import { PieChart, Pie, Cell, Tooltip } from 'recharts';

export default function RenderPie({groupedData, scale = 'like-dislike'}){
  
     
  
      console.log(groupedData);

      const ResultBox = ({ promoters, detractors, total }) => {
        
          return (
            <div className={`border border-slate-500 p-1  
             

            `}>

              <p className="text-xs text-slate-700">
                Número de detractores: {detractors} ({Math.round(detractors/total*100)}%)<br/>
                Número de promotores: {promoters} ({Math.round(promoters/total*100)}%)
              </p>
              
        
            </div>
          );
        
      
        
      };
      
      const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

      const RADIAN = Math.PI / 180;
      let detractors = 0;
      let promoters = 0;
      let total = 0;

      const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
          <text className="small" x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${(percent * 100).toFixed(0)}%`}
          </text>
        );
      };

      const data = groupedData;
      
      
      if (Array.isArray(data) && data.length > 0) {
        for (let i=0; i<data.length; i++){
          total += parseInt(data[i].value, 10)

          if(scale === '5-points'){
            if(data[i].name <= 3){
              detractors += parseInt(data[i].value, 10)
            } else {
              promoters += parseInt(data[i].value, 10)
            }
          } else {
            if(data[i].name === '0'){
              detractors += parseInt(data[i].value, 10)
            } else {
              promoters += parseInt(data[i].value, 10)
            }
          }
          
          
          data[i].value = parseInt(data[i].value, 10)
       
        }
      } 
          
      

         
      
    if(Array.isArray(groupedData) && groupedData.length > 0){
      return(
          <div className="">
            
              <div className="bg-neutral-100 border border-slate-700 rounded-md mb-2">
            <PieChart width={160} height={150}>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={renderCustomizedLabel}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
            <ResultBox promoters={promoters} detractors={detractors} total={total}/>
          </div>
            
          
            
              
          </div>
      );
    } else  {
      return null;
    }
    
    
     
    
    }//end avg_odo